import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  let board = useDataValue({
    viewPath: props.viewPath,
    context: 'board',
  })

  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.board_id',
  })

  return useMemo(() => {
    if (id !== 'new') return board

    if (!rdata) return rdata

    let { stages, ...data } = rdata

    return {
      stages: [...stages].sort((a, b) => a.order - b.order),
      ...data,
    }
  }, [rdata, board, id])
}
